module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAErCAYAAAAId3mkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAABzSURBVGhD7cqhAYAwAMCwjU/4/wxO2SHDICJncI2p6Vxr7XFo7uc+nq+vR5rVrGY1q1nNalazmtWsZjWrWc1qVrOa1axmNatZzWpWs5rVrGY1q1nNalazmtWsZjWrWc1qVrOa1axmNatZzWpWs5r11zzGC5gICN9DLVqhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/warning.png
// module id = 729
// module chunks = 1